export enum DriverLevelQueryKeys {
  CompanyList = 'driverLevelCompanyList'
}
